import {Box, CircularProgress, Typography} from "@mui/material";
import {useNavigate, useParams} from "react-router-dom";
import useAxios from "axios-hooks";
import {API_URL, mezzoTrasportoValues} from "../config";
import {useTranslation} from "react-i18next";
import FormContainer from "../components/FormContainer";
import {useEffect, useState} from "react";
import {useDataStore} from "../state/state";
import dayjs from "dayjs";
import AgencyFormContainer from "../components/AgencyRegistrationForm/AgencyFormContainer";

const Register = () => {
    const {id} = useParams()
    const {initializeAgency} = useDataStore()

    const {t, i18n} = useTranslation()
    const navigate = useNavigate()

    const [{data, loading, error}, refetch] = useAxios(`${API_URL}agency/${id}`)
    const [errorCategoria, setErrorCategoria] = useState(false)

    //const data = {nome: "Matilde", cognome: 'Ugolini', richiestaDocumenti: 'si'}
    const _data = {
        numeroInviti: 2,
        email: "matilde@plesh.co",

        categoria: "DIPENDENTI",

        /*indirizzo: "Indirizzo di residenza",
        cap: "10123",
        provincia: "provincia",
        citta: "citta",
        paese: "paese",
        luogoNascita: "IluogoNascita",
        dataNascita: null,*/

        richiestaDocumenti: 'no',
        cittaPartenzaArrivo: "cittaPartenza",
        dataPartenza: dayjs(),
        dataRitorno: dayjs(),
        mezzoTrasporto: mezzoTrasportoValues[1]?.value,
    }

    useEffect(() => {
        if (data)
            initializeAgency(data)
    }, [data])

    useEffect(() => {
        if (data) {
            if (data.categoria !== 'AGENZIA ITA') {
                //console.log("data.categoria:", data.categoria)
                setErrorCategoria(true)
            } else {
                if (!!data.lang) {
                    i18n.changeLanguage(data?.lang || 'it')
                }
            }/*else if(!!data.partecipazione) {
                navigate('/success')
            }*/
        }

    }, [data])

    return (
        <Box margin={"auto"}>
            {
                loading ?
                    <Box sx={{textAlign: 'center'}}>
                        <CircularProgress/>
                    </Box>
                    : (error || errorCategoria) ?
                        <Typography textAlign={'center'}>
                            {t('shared.user-not-available')}
                        </Typography>
                        : data ? <AgencyFormContainer/>

                            : null
            }
        </Box>
    )
}

export default Register